import "./bootstrap";

import "vue-multiselect/dist/vue-multiselect.min.css";
import flatPickr from "vue-flatpickr-component";
import VueQuillEditor from "vue-quill-editor";
import Notifications from "vue-notification";
import Multiselect from "vue-multiselect";

import VeeValidate, { Validator } from "vee-validate";
import "flatpickr/dist/flatpickr.css";
import VueCookie from "vue-cookie";
import { Admin } from "craftable";
import VModal from "vue-js-modal";
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import BrowserAlert from "./components/basic/BrowserAlert";
import MaintenanceNotification from "./components/basic/MaintenanceNotification";

import "./app-components/bootstrap";
import "./index";

import { formatHours, formatDays, formatMoney } from './utils'

Vue.filter('formatHours', formatHours);
Vue.filter('formatDays', formatDays);
Vue.filter('formatMoney', function(value, currencySymbol, minDecimals = 2, maxDecimals = 2) {
    return formatMoney(value, currencySymbol, minDecimals, maxDecimals)
})
Vue.filter('formatMoneyExtended', function(value, currencySymbol) {
    // like formatMoney but keeps up to 4 decimals (salary is decimal(10,4)) so values aren't visually rounded to 2
    return formatMoney(value, currencySymbol, 2, 4)
})

import "craftable/coreui";
import PdfLoader from "./components/basic/PdfLoader.vue";

var userLanguage = document.documentElement.lang;

Vue.component('multiselect', Multiselect);
Vue.use(VeeValidate, {strict: true});
Vue.component('datetime', flatPickr);
Vue.use(VModal, { dialog: true });
Vue.use(VueQuillEditor);
Vue.use(Notifications);
Vue.use(VueCookie);
Vue.use(BootstrapVue);
Vue.component('browser-alert', BrowserAlert);
Vue.component('maintenance-notification', MaintenanceNotification);
Vue.component('pdf-loader', PdfLoader);

let VeeLocale = require('vee-validate/dist/locale/'+userLanguage);
Validator.localize(userLanguage, VeeLocale);

new Vue({
    mixins: [Admin],
});

moment.locale(userLanguage);


$(document).ready(function($){
    SidebarInit();
    $('.restaurants-selector').select2({
        matcher: restaurantSelectorMatchCustom
    });

    removeCoreUiForMultichoice();
});

function SidebarInit()
{
    // Add class .active to current link
//    if(!$("body").hasClass("sidebar-mini"))
//    {
//        $('.sidebar').find('a.active').each(function(){
//            $(this).parents('.dropdown').addClass('open');
//        });
//    }

    // Check if user has a saved sidebar preference
    var savedSidebarState = VueCookie.get('sidebar-expand');

    if(savedSidebarState !== null) {
        // Apply saved preference (0 = collapsed/sidebar-mini, 1 = expanded/no class)
        if(savedSidebarState === '0') {
            $("body").addClass("sidebar-mini");
        } else {
            $("body").removeClass("sidebar-mini");
        }
    } else {
        $("body").addClass("sidebar-mini");
    }

    $("body").on("click", function(e) {
        if($(e.target).closest("#sidebarMenu").length == 0)
        {
            $(".sidebar-mini .sidebar-nav li.dropdown.open").removeClass("open");
        }

        // closing dropdown-multichoice/singlechoice components when clicking outside or on another simmilar component
        if($('.dropdown-multichoice.open, .dropdown-singlechoice.open').length > 0 ) {
            $('.dropdown-multichoice.open, .dropdown-singlechoice.open').each(function() {
                if($(e.target).closest(".dropdown").length === 0 || $(e.target).closest(".dropdown")[0].id !== $(this)[0].id) {
                    $(this).removeClass('open');
                }
            });
        }
    });

    $("body").on("click", "a.nav-link", function(e) {
        if($("body").hasClass("sidebar-mini"))
        {
            if($(this).parent().hasClass("nav-item"))
            {
                var x = $(this).hasClass("dropdown") ? $(this) : $(this).closest(".dropdown");
                $(".sidebar-mini .sidebar-nav li.dropdown.open").removeClass("open");
                x.addClass("open");
                fitSidebarDropdownToViewport(x);
            }
        }
    });

    $(window).on("resize", function() {
        $(".sidebar-mini .sidebar-nav li.dropdown.open").each(function() {
            fitSidebarDropdownToViewport($(this));
        });
    });

    $(".sidebar-collapse").on("click", function() {
        var expandedSetting = ($("body").hasClass("sidebar-mini") ? 0 : 1);
        VueCookie.set('sidebar-expand', expandedSetting, { expires: '1Y' });
    });
}

// keeps the opened sidebar submenu inside the viewport (large zoom / font size) - it stays aligned with its icon
// and its items become scrollable when they do not fit below it
function fitSidebarDropdownToViewport(dropdown)
{
    var menu = dropdown.find('.dropdown-menu-items');
    if(menu.length === 0) {
        return;
    }

    menu.css({ maxHeight: '', overflowY: '' });

    var availableHeight = window.innerHeight - dropdown[0].getBoundingClientRect().top;

    if(menu.outerHeight() > availableHeight) {
        menu.css({ maxHeight: availableHeight + 'px', overflowY: 'auto' });
    }
}

function removeCoreUiForMultichoice() {
    $('.dropdown-multichoice .dropdown-menu').off('mouseout');
    $('.dropdown-multichoice .dropdown-menu').off('mouseleave');
    $('.dropdown-multichoice .dropdown-item').off('click');
}

function restaurantSelectorMatchCustom(params, data) {
    if ($.trim(params.term) === '') {
    return data;
  }

  const term = normalizeText(params.term);

  // Match individual option
  if (data.text) {
    const optionText = normalizeText(data.text);
    if (optionText.includes(term)) {
      return data;
    }
  }

  // Match group label or its children
  if (data.children && data.children.length > 0) {
    const groupLabel = normalizeText(data.text || '');

    if (groupLabel.includes(term)) {
      // Return all children in group if group label matches
      return $.extend({}, data, true);
    }

    // Recursively match children with same matcher
    const matchingChildren = data.children
      .map(child => restaurantSelectorMatchCustom(params, child))
      .filter(child => child != null);

    if (matchingChildren.length) {
      return $.extend({}, data, {
        children: matchingChildren
      });
    }
  }

  return null;
}

// Helper function to remove diacritics from text (e.g. "Košice" -> "Kosice")
function normalizeText(text) {
  return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}



// WEBPACK FOOTER //
// ./resources/assets/admin/js/admin.js